// Dependencies
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const Envelope = (props) => {
  let classNameEnvelope = classNames(
    "c-envelope",
    props.envelopClassName && props.envelopClassName
  );

  return (
    <svg
      className={classNameEnvelope}
      width={props.width ? props.width : "30px"}
      height={props.height ? props.height : "24px"}
      viewBox="0 0 30 24"
    >
      <g
        id="Folder-(Show)-"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="01_Desktop-Copy-7"
          transform="translate(-1349.000000, -803.000000)"
          fill={props.color ? props.color : "#121A22"}
          className='filled'
        >
          <g id="Table" transform="translate(367.000000, 750.000000)">
            <g id="02_Row" transform="translate(0.000000, 50.000000)">
              <g id="Group-12" transform="translate(917.000000, 2.000000)">
                <g id="Envelope" transform="translate(65.000000, 1.000000)">
                  <g id="Folder">
                    <path
                      d="M6.93391219,23.9728278 C8.76113007,23.6753818 11.0029479,24.554646 12.7434498,24.4806358 C16.8235182,24.3068524 20.0977824,24.0091302 24.1806765,23.9728278 C24.8834119,23.9662699 25.1260755,23.6276031 25.0473069,22.7141864 C24.8805861,20.77868 23.8577177,15.3817118 23.7162523,13.4424579 C23.3284144,8.13199397 23.1422414,6.0785095 22.7946709,0.763361357 C22.7190813,-0.395272551 22.3448425,-0.953159344 21.5137109,-1.03864578 C20.4303788,-1.14989524 19.412813,-1.27965752 18.3278914,-1.30050215 C15.6532937,-1.35226243 13.3393718,-0.790575952 10.6640676,-0.790341742 C9.35008145,-0.790107533 8.03574204,-0.762470824 6.72175585,-0.728042042 C6.17461483,-0.713286849 5.78147864,-0.551682363 5.80655741,0.415602464 C5.93742619,5.48061497 5.6929965,9.34124518 5.80655741,14.4071945 C5.88144049,17.7495969 6.34881099,18.474091 6.43323107,21.5747892 L6.93391219,23.9728278 Z M22.1909391,-2.59550641 C23.657164,-2.47472549 24.0900377,-1.99814915 24.2069542,-0.590301981 C24.4630402,2.49641716 24.6405343,5.59054511 24.9663817,8.67002773 C25.4070263,12.8337818 25.972005,16.9849582 26.4469121,21.1452663 C26.543695,21.9917665 26.4765828,22.8558411 26.4885923,23.71199 C26.4908883,23.8691258 26.4659861,24.0465928 26.5299193,24.1799514 C26.9486641,25.05557 26.8638908,25.436004 25.9059525,25.6991031 C24.8978566,25.9759861 23.8381903,26.1806761 22.7949489,26.2108283 C18.0932096,26.3464268 13.3898808,26.4239609 8.70474298,25.8484855 C7.86919612,25.7457959 7.02216954,25.6832517 6.18114774,25.6884207 C5.56442196,25.6923835 5.42030735,25.3122941 5.34136221,24.887924 C4.97930957,22.9433685 4.56586311,21.003465 4.3163117,19.0442642 C3.49330422,12.585845 3.68280787,6.09589522 3.79177689,-0.389230185 C3.81155733,-1.55999527 4.38042151,-2.281924 5.65802582,-2.54967513 C6.65711451,-2.75918953 7.69382135,-2.84706153 8.71763559,-2.8839333 C10.2152973,-2.93786259 11.7163146,-2.89771715 13.2159189,-2.89771715 C13.2203342,-3.00884937 13.2249261,-3.1198093 13.2293414,-3.23076923 C16.2168939,-3.02280551 19.2067423,-2.84154799 22.1909391,-2.59550641 Z"
                      id="Fill-5"
                      transform="translate(15.230769, 11.538462) rotate(-90.000000) translate(-15.230769, -11.538462) "
                    ></path>
                  </g>
                  <g id="Close" transform="translate(1.846154, 1.846154)">
                    <path
                      d="M6.9176427,-0.713734649 C6.69709081,-0.714070073 6.4773728,-0.298343296 6.25848868,0.533445681 L6.25968937,2.31979281 C6.42764968,4.04638805 6.53880102,5.76121296 6.59314338,7.46426753 C6.67465692,10.0188494 6.26651348,12.4724609 6.59678638,12.884196 C6.92705928,13.295931 7.7122062,14.6994901 7.98424186,13.7080356 C8.25627753,12.716581 7.98237003,10.9231901 7.98180351,10.0803466 C7.98142583,9.51845086 7.86983163,8.2460379 7.6470209,6.26310768 C7.64570657,4.30768445 7.64493647,3.16196062 7.64471061,2.82593619 C7.64448475,2.48991176 7.64397159,1.7264505 7.64317113,0.535552412 C7.3800374,-0.296969934 7.13819458,-0.713398954 6.9176427,-0.713734649 Z"
                      id="Path-8"
                      transform="translate(7.181566, 6.670881) rotate(-56.000000) translate(-7.181566, -6.670881) "
                    ></path>
                    <path
                      d="M19.4746431,-2.85285637 C19.2522966,-2.85247866 19.0302268,-2.38395872 18.8084339,-1.44729657 L18.8072234,0.56266227 C18.9742108,2.5048185 19.0839429,4.43392548 19.1364195,6.34998321 C19.2151344,9.22406981 18.8003438,11.986223 19.1327468,12.4483685 C19.4651499,12.910514 20.2547852,14.4870831 20.5303786,13.3705864 C20.8059721,12.2540896 20.5322657,10.237139 20.5328368,9.2887898 C20.5332176,8.656557 20.4224395,7.22524483 20.2005026,4.99485329 C20.2018276,2.79465371 20.202604,1.50551023 20.2028317,1.12742287 C20.2030594,0.749335505 20.2035767,-0.109694456 20.2043837,-1.44966701 C19.9402365,-2.385504 19.6969897,-2.85323379 19.4746431,-2.85285637 Z"
                      id="Path-8"
                      transform="translate(19.730300, 5.454836) rotate(-304.000000) translate(-19.730300, -5.454836) "
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

Envelope.propTypes = {
  className: PropTypes.string,
};

export default Envelope;
